import React, { useState } from "react";

const MeditationType = ({ label, categories, selected, setSelected }) => {
  const [addingCustom, setAddingCustom] = useState(false);
  const [customType, setCustomType] = useState("");

  const handleSelect = (name) => {
    setSelected(selected === name ? "" : name);
    setAddingCustom(false);
  };

  const isCustom = selected && !categories.includes(selected);

  return (
    <div className="tw-mb-6">
      <label className="tw-block tw-mb-3">{label}</label>
      <div className="tw-flex tw-flex-wrap tw-gap-2">
        {categories.map((name) => (
          <button
            key={name}
            type="button"
            onClick={() => handleSelect(name)}
            className={`tw-px-2 lg:tw-px-5 tw-py-2 tw-rounded-full tw-text-sm lg:tw-text-base tw-border ${
              selected === name
                ? "tw-bg-black tw-text-white hover:tw-bg-gray-900"
                : "tw-bg-white tw-text-black hover:tw-bg-gray-100"
            }`}
          >
            {name}
          </button>
        ))}

        {isCustom && !addingCustom && (
          <div className="tw-flex tw-items-center tw-bg-black tw-text-white tw-text-sm lg:tw-text-base tw-px-3 lg:tw-px-5 tw-py-2 tw-rounded-full">
            {selected}
            <button
              type="button"
              onClick={() => setSelected("")}
              className="tw-ml-2 tw-text-white hover:tw-text-gray-300"
            >
              &times;
            </button>
          </div>
        )}

        <button
          type="button"
          onClick={() => {
            setAddingCustom(true);
            setSelected("");
          }}
          className={`tw-px-2 lg:tw-px-5 tw-py-2 tw-rounded-full tw-border tw-text-sm lg:tw-text-base ${
            addingCustom
              ? "tw-bg-black tw-text-white"
              : "tw-bg-gray-100 tw-text-black"
          }`}
        >
          + Add your own
        </button>
      </div>

      {addingCustom && (
        <input
          type="text"
          className="tw-mt-3 tw-border tw-rounded-full tw-p-4 tw-w-full"
          placeholder="Enter custom type and press Enter"
          value={customType}
          onChange={(e) => setCustomType(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && customType.trim()) {
              const name = customType.trim();
              setSelected(name.charAt(0).toUpperCase() + name.slice(1));
              setCustomType("");
              setAddingCustom(false);
            }
          }}
        />
      )}
    </div>
  );
};

export default MeditationType;
